export const TEXTBOX_CHANGED = 'settings/TEXTBOX_CHANGED';
export const textboxChanged = payload => ({
  type: TEXTBOX_CHANGED,
  payload,
});



// WEBPACK FOOTER //
// ./app-settings/actions/textbox-changed.js